/**
 * Here left, right and center are fixed to handle pdf classes and excel CellOptions(kendo)
 */
export enum exportAlign {
    left = 'left',
    center = 'center',
    right = 'right'
}
